export default {
      id: "oc-star-usage",
      viewBox: "0 0 1068 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-star",
      toString: function () {
        return this.url;
      }
    }